import { render } from "./CounselMigrationPanel.vue?vue&type=template&id=aa71ddfa&scoped=true"
import script from "./CounselMigrationPanel.vue?vue&type=script&lang=js"
export * from "./CounselMigrationPanel.vue?vue&type=script&lang=js"

import "./CounselMigrationPanel.vue?vue&type=style&index=0&id=aa71ddfa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa71ddfa"]])

export default __exports__